import { destroy } from "@/application/api";

export const conceptProductDestroy = ({
  clientId,
  productId,
}: {
  clientId: number;
  productId: number;
}) => destroy(`client/${clientId}/product/concept/${productId}`);
